export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}scorm/course`;
    const url = `${baseUrl}`;

    return $resource(url, null, {
        preview: {
            method: 'GET',
            url: `${url}/preview`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/ScormCloud/index.js